import React from "react";
import SFIconButton from "../button/iconButton";
import { SFArrowUpIcon } from "../icons";
import useScrollTrigger from "@mui/material/useScrollTrigger";
import Zoom from "@mui/material/Zoom";

import { styled } from "@mui/material/styles";

const StyledUpBtn = styled("div", { shouldForwardProp: false })(
  ({ theme }) => ({
    position: "fixed",
    right: 26,
    bottom: 15,
    "& 	.MuiIconButton-root":{
      backgroundColor: theme.palette.primary.main,
      boxShadow: "0 2px 4px 0 rgb(0 0 0 / 30%)",      
      "& .MuiSvgIcon-root": {
        color: theme.palette.primary.contrastText,
      },
      "&:hover": {
        backgroundColor: theme.palette.primary.contrastText,
        "& .MuiSvgIcon-root": {
          color: theme.palette.primary.main,
        },
      },
    }
  })
);

const SFScrollToTopBtn = () => {
  const trigger = useScrollTrigger({
     
    target: window,
    disableHysteresis: true,
    threshold: 100,
  });

  const handleClick = (event) => {
    const anchor = (event.target.ownerDocument || document).querySelector(
      ".scroll-to-top-el"
    );
    if (anchor) {
      anchor.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  };

  return (
    <Zoom in={trigger}>
      <StyledUpBtn>
        <SFIconButton type="button" onClick={handleClick}>
          <SFArrowUpIcon size="large"/>
        </SFIconButton>
      </StyledUpBtn>
    </Zoom>
  );
};

export default SFScrollToTopBtn;
